<template>
  <div class="meun-box">
    <div class="meun-content">
      <div v-if="!isShowSearch" class="meun-search">
        <el-input
          v-model="storeName"
          class="w-50 m-2"
          placeholder="搜索名称"
          :prefix-icon="Search"
          clearable
          @keyup.enter="query"
        />
        <el-button
          style="margin-left: 8px"
          size="default"
          type="primary"
          @click="query"
        >
          搜索
        </el-button>
        <div
          v-if="!isShowSortBtn"
          class="sort_box"
          :style="{ background: isDrag ? '#FFAC2E' : '#FFF' }"
          @click="changeSort"
        >
          <img
            v-if="!isDrag"
            src="https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20230413/W8Aiai5TYWIhrv0m.png"
            alt=""
          />
          <img
            v-else
            src="https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20230413/r7EGQL9cIHwNgj0a.png"
            alt=""
          />
        </div>
      </div>
      <div class="meun-list" :class="isShowSearch ? 'meun-height' : ''">
        <el-tree
          v-if="showTreeMenu"
          ref="treeRef"
          v-loading="treeLoading"
          :node-key="nodeKey"
          :show-checkbox="isShowCheckBox"
          :data="list"
          :props="props"
          :draggable="isDrag"
          :filter-node-method="filterMethod"
          highlight-current
          :allow-drop="allowDrop"
          :current-node-key="id"
          :empty-text="emptyText"
          :expand-on-click-node="false"
          :default-checked-keys="checkBoxList"
          :default-expanded-keys="keys"
          @node-drop="nodeDrop"
          @node-click="handleTreeItem"
          @check="handleCheckChange"
          @node-expand="handleNodeExpand"
          @node-collapse="handleNodeExpand"
          :default-expand-all="showAll"
        >
          <template #default="scope">
            <span class="custom-tree-node">
              <span
                :id="scope.data.id"
                :class="{
                  btn: isShowBtn(scope.data.type),
                  activeType:
                    scope.data[type == 1 ? 'orderNumber' : 'id'] == activeId,
                }"
                :style="{ color: scope.data.status == 0 ? '#A3A9B4' : '' }"
              >
                <slot :row="scope" name="name" />
                {{ scope.data[nodeName] }}
                <span v-if="scope.data.size" class="size">{{
                  scope.data.size
                }}</span>
              </span>
            </span>
            <slot :row="scope" name="more" />
          </template>
        </el-tree>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import setTotalData from "@/data/data";
import { Search } from "@element-plus/icons-vue";
import {
  ref,
  defineProps,
  defineEmits,
  getCurrentInstance,
  watch,
  computed,
} from "vue";
import type { AllowDropType } from "element-plus/es/components/tree/src/tree.type";
import type Node from "element-plus/es/components/tree/src/model/node";
import instance from "@/api/request";

// import treeList from "@/page/menu/data/treeList";
const app = getCurrentInstance()?.proxy;
const storeName = ref("");
const isDrag = ref(false);
const keys = computed(() => {
  // const launch = propsData.list.map((f) => f[propsData.nodeKey]);

  return propsData.id ? [0, propsData.id] : [0];
});
const emptyText = ref("暂无搜索结果");
const props = {
  value: "id",
  label: "label",
  children: "children",
};

interface Props {
  list: TreeList[];
  id: string | number; // 当前选中节点
  nodeName: string;
  type: number | string;
  isShowSearch: boolean; // 是否显示搜索框
  isShowCheckBox: boolean; // 是否显示勾选
  isShowSortBtn: boolean; // 是否显示排序按钮
  checkBoxList: number[]; // 勾选时选中的id
  sortUrl: string; // 排序地址
  sortName: string; // 排序名称
  nodeKey: string;
  isSkipLevel: boolean;
  deepLevel: number;
  isSeparatelyDeal: boolean;
  treeLoading: boolean;
  showAll:boolean;
  showTreeMenu:boolean;
}

const propsData = withDefaults(defineProps<Props>(), {
  list: () => [],
  id: "", // 当前选中节点
  nodeName: "",
  type: "",
  isShowSearch: false, // 是否显示搜索框
  isShowCheckBox: false, // 是否显示勾选
  checkBoxList: () => [], // 勾选时选中的id
  sortUrl: "", // 排序地址
  sortName: "", // 排序名称
  nodeKey: "id",
  isSeparatelyDeal: false, // 拖拽请求是否单独处理
  isSkipLevel: false, // 拖拽是否可以跨级
  deepLevel: 1, // 拖拽层次
  treeLoading: false,
  showAll:false,
  showTreeMenu:true,//用于数据更新保留展开效果
});

const emits = defineEmits<{
  (e: "nodeClick", data: TreeList, id: number, name: string, parent: any): void;
  (e: "nodeDisabled", falg: boolean): void;
  (e: "changeDisabled", nodes: any, keys: any): void;
  (e: "sortSave"): void;
  (
    e: "changeNodeDrop",
    draggingNode: Node,
    dropNode: Node,
    type: AllowDropType
  ): void;
  (e: "nameSearch",storeName:string): void;

}>();

const treeRef = ref();

const handleCheckChange = (checkedNodes: any, checkedKeys: any) => {
  emits("changeDisabled", checkedNodes, checkedKeys);
  console.log('handleCheckChange',checkedNodes,checkedKeys);
};

const activeBoxList = computed(() => {
  return [
    ...treeRef.value.getCheckedKeys(),
    ...treeRef.value.getHalfCheckedKeys(),
  ];
});

// 搜索过滤
const filterMethod = (query: string, data: TreeList, node: Node) => {
  return findSearKey(node, query);
};

// 搜索查询
const query = () => {
  treeRef.value?.filter(storeName.value);
  linearInit();
  //门店名称搜索排序
  emits("nameSearch",storeName.value);
};

const handleNodeExpand = () => {
  linearInit();
};

// 树形线形样式
const linearInit = () => {
  // 此次不能用nextTick ，因为el-tree组件的default-expanded-keys方法会顶替掉
  setTimeout(() => {
    const list = document.querySelectorAll(".el-tree-node__children");
    list.forEach((v) => {
      if (v.children.length && v.children) {
        let num = 0;
        for (let i = 0; i < v.children.length; i++) {
          if (
            !v.children[v.children.length - 1 - i].classList.value.includes(
              "is-hidden"
            ) &&
            num == 0
          ) {
            num++;
            v.children[v.children.length - 1 - i].classList.add("active");
          } else {
            v.children[v.children.length - 1 - i].classList.remove("active");
          }
        }
      }
    });
  });
};

// 拖拽
const allowDrop = (draggingNode: Node, dropNode: Node, type: AllowDropType) => {
  const dataType = draggingNode.data.type;
  const fromLevel = draggingNode.level;
  const toLevel = dropNode.level;

  // 按钮不能拖拽
  if (setTotalData.isShowBtnList.includes(dataType)) {
    return false;
  }

  // 菜单功能中的tab栏不能跨级跳转 tab标识TG
  if (propsData.isSkipLevel && draggingNode.data?.menuType !== "TG") {
    // 可跨级拖拽
    const flag1 = fromLevel === toLevel && type !== "inner"; // 可同级拖拽不可同级嵌入
    const flag2 =
      type === "inner" &&
      toLevel <= propsData.deepLevel &&
      toLevel + 1 === fromLevel; // 嵌入判断

    return flag1 || flag2;
  } else {
    // 不可跨级拖拽
    return (
      fromLevel === toLevel &&
      draggingNode.parent.id === dropNode.parent.id &&
      type !== "inner"
    );
  }
};

//递归搜索父级是否包含关键字
const findSearKey = (node: Node, key: string): boolean => {
  if (node.data[propsData.nodeName].indexOf(key) !== -1) {
    return true;
  } else {
    if (node.parent.parent == null) {
      return false;
    } else {
      return findSearKey(node.parent, key);
    }
  }
};

const activeId = ref();

const handleTreeItem = (data: TreeList, node: Node) => {
  console.log(data,node);
  linearInit();
  const id = ["id", "orderNumber"];
  if (activeId.value == data[id[propsData.type || 0]]) return;
  activeId.value = data[id[propsData.type || 0]];
  if (!node.expanded) node.expanded = true;
  const parentId = node.parent.data.id;

  const parentName = node.parent.data.name;
  disabled(+data.id);
  emits("nodeClick", data, parentId, parentName, node.parent.data);
};

const disabled = (id: number) => {
  const disabled = activeBoxList.value.includes(id);
  emits("nodeDisabled", disabled);
};
const nodeDropId = {};

const changeSort = () => {
  if (!app?.$app.isShowBtn("Sort")) {
    return app?.$message.error("没权限访问");
  }
  if (isDrag.value) {
    propsData.isSeparatelyDeal ? emits("sortSave") : saveSort();
  } else {
    sortFn();
  }
};
const sortFn = () => {
  if (!propsData.sortUrl) return app?.$message.error("不可排序");
  isDrag.value = true;
};
const saveSort = async () => {
  if (JSON.stringify(nodeDropId) != "{}") {
    const list = [] as any[];
    for (const i in nodeDropId) {
      nodeDropId[i].forEach((f: TreeList, index: number) => {
        list.push({
          id: f.id,
          [propsData.sortName]: index,
          type: f.type,
        });
      });
    }
    await instance.post(propsData.sortUrl, list).then((res: any) => {
      if (res.code == 200) {
        app?.$message.success("保存成功！");
      } else {
        app?.$message.error(res.message);
      }
    });
  } else {
    app?.$message.success("保存成功！");
  }
  isDrag.value = false;
};

const nodeDrop = (draggingNode: Node, dropNode: Node, type: AllowDropType) => {
  if (propsData.isSeparatelyDeal) {
    emits("changeNodeDrop", draggingNode, dropNode, type);
    return;
  }
  const Item = filterParentId(propsData.list, draggingNode.data.id);
  nodeDropId[Item.id] = Item.children;
};

const filterParentId = (list: TreeList[], id: number): any => {
  let activeId = {} as TreeList;
  list.forEach((f) => {
    if (f.children) {
      const Item = f.children.find((v) => v.id == id);
      if (Item) {
        activeId = f;
      }
    }
  });
  if (activeId.id) {
    return activeId;
  } else {
    for (const f of list) {
      if (f.children?.length) {
        const itemId = filterParentId(f.children, id);
        if (itemId) return itemId;
      }
    }
  }
};

const isShowBtn = (type: number) => {
  return setTotalData.isShowBtnList.includes(type);
};

watch(
  () => propsData.id,
  () => {
    activeId.value = propsData.id;
  }
);

defineExpose({
  treeRef,
  activeBoxList,
  handleCheckChange,
  activeId,
  isDrag,
});
</script>
<style scoped lang="scss">
//处理树节点复选框勾选样式
:deep(.el-checkbox__inner)::before {
  top: 110% !important;
  background-repeat: no-repeat !important;
}
.meun-box {
  width: 300px;
  height: 100%;
  background: #f2f6fb;
  padding: 8px;
  box-sizing: border-box;
  border-radius: 5px;
  .meun-content {
    width: 100%;
    height: 100%;
    // background: #ffffff;
    border-radius: 6px;
    .meun-search {
      padding: 14px;
      box-sizing: border-box;
      display: flex;
      background-color: #fff;
      border-radius: 6px;
      margin-bottom: 8px;
      .el-input {
        width: 160px;
        flex: 1;
      }
      .el-button {
        width: 50px;
      }
      .sort_box {
        width: 32px;
        height: 32px;
        border: 1px solid #d1d4d9;
        border-radius: 5px;
        background: #fff;
        margin-left: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        user-select: none;
        img {
          width: 18px;
          height: 18px;
        }
      }
    }
  }
}

.meun-list {
  height: calc(100% - 70px);
  overflow: auto;
  background-color: #fff;
  border-radius: 6px;
  padding-top: 8px;
  box-sizing: border-box;
  :deep(.el-tree-node) {
    position: relative;
    padding-left: 6px;
    background-color: #fff;
  }
  :deep(.el-tree-node__children) {
    padding-left: 16px;
  }

  :deep(.el-tree-node) :last-child:before {
    height: 30px;
  }

  :deep(.el-tree > .el-tree-node):before {
    border-left: none;
  }

  :deep(.el-tree > .el-tree-node):after {
    border-top: none;
  }

  :deep(.el-tree-node):before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
    border-left: 1px dashed #5893f5;
    bottom: 0px;
    height: 100%;
    top: -18px;
    width: 1px;
  }

  :deep(.el-tree-node):after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
    border-top: 1px dashed #5893f5;
    height: 20px;
    top: 12px;
    width: 18px;
  }
  // :deep(.el-tree .el-tree-node__expand-icon.expanded) {
  //   -webkit-transform: rotate(0deg);
  //   transform: rotate(0deg);
  // }
  :deep(.el-tree .el-icon-caret-right):before {
    content: "\e723";
    font-size: 16px;
    color: #5893f5;
    position: absolute;
    left: -20px;
    top: -8px;
  }
  :deep(
      .el-tree .el-tree-node__expand-icon.expanded.el-icon-caret-right
    ):before {
    content: "\e722";
    font-size: 16px;
    color: #5893f5;
    position: absolute;
    left: -20px;
    top: -8px;
  }
  :deep(.el-tree-node__expand-icon.is-leaf):before {
    content: "";
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #5893f5;
    border: 1px solid #5893f5;
    font-size: 16px;
    color: #5893f5;
    position: absolute;
    left: -18px;
    top: 2px;
  }

  :deep(.el-tree-node__expand-icon.is-leaf svg) {
    display: none;
  }
  :deep(.el-tree-node__content > .el-tree-node__expand-icon) {
    // color: transparent;
    margin-bottom: 11px;
    color: #5893f5;
    padding: 6px;
    visibility: inherit;
  }
  :deep(.el-tree-node__expand-icon.is-leaf) {
    margin: 0;
    margin-right: 5px;
    margin-top: 2px;
  }

  :deep(.el-tree-node__content > .el-tree-node__expand-icon):before {
    content: "";
    width: 7px;
    height: 7px;
    border-radius: 50%;
    // background-color: #6288d1;
    font-size: 16px;
    color: #5893f5;
    position: absolute;
    left: 9px;
    top: 2px;
  }

  :deep(.el-tree-node > .el-tree-node__children) {
    overflow: visible !important;
  }

  :deep(.el-tree-node__content) {
    height: 36px;
    border-radius: 5px;
    padding: 0 !important;
  }

  :deep(.el-tree-node__content):hover .more {
    display: flex !important;
  }

  :deep(.el-tree-node:focus > .el-tree-node__content),
  :deep(.el-tree-node__content):hover {
    background-color: transparent;
  }

  .active {
    background-color: #d3e3fa;
  }

  :deep(.custom-tree-node) {
    line-height: normal;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
    margin-bottom: 10px;
  }

  :deep(.el-checkbox__inner) {
    margin-bottom: 10px;
  }

  :deep(.custom-tree-node):nth-of-type(1) span {
    max-width: 150px;
    padding: 5px 11px;
    border-radius: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  :deep(.custom-tree-node):nth-of-type(1) span:hover {
    background-color: #d3e3fa;
  }
  :deep(
      .el-tree--highlight-current
        .el-tree-node.is-current
        > .el-tree-node__content
    ) {
    background: transparent;
  }
}

.meun-height {
  height: 100%;
}

:deep(.el-tree-node__content .more-box .more) {
  color: #5893f5;
  display: none !important;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  position: relative;
  color: #5893f5;

  .btn {
    color: #fff;
    background-color: #5893f5;
    margin-left: 16px;
    overflow: visible !important;
    position: relative;
  }
  .btn:hover {
    background-color: #3172de !important;
  }
  .size {
    width: 20px;
    height: 12px;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #96bdff !important;
    border-radius: 50px;
    position: absolute;
    right: -10px;
    top: -6px;
  }

  .activeType {
    background-color: #3172de;
    color: #fff;
  }
  .activeType:hover {
    background-color: #3172de !important;
    color: #fff;
  }
}

:deep(.el-tree-node__content > label.el-checkbox) {
  position: absolute;
  right: 0;
}

.custom-tree-img {
  width: 18px;
  height: 18px;
  margin-left: -10px;
  z-index: 99;
}

.custom-tree-block {
  width: 8px;
  height: 8px;
  background-color: #5893f5;
  border-radius: 50%;
  margin-left: -4px;
  z-index: 99;
}

:deep(.transparent) {
  opacity: 0 !important;
}

:deep(.active)::before {
  height: 30px !important;
}
:deep(.el-button--primary) {
  background: $--color-main !important;
}

:deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner)::before {
  height: 2px !important;
}
</style>
